import * as AbsintheSocket from '@absinthe/socket';
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link';
import { ApolloLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { createLink } from 'slab-apollo-absinthe-upload-link';
import { createOrGetSocket } from '../../utils/createOrGetSocket';
import { getAuthToken } from './authLink';

const { host } = window.location;
const abortController = new AbortController();

const httpLink = createLink({
  fetchOptions: { signal: abortController.signal },
  uri: (operation) =>
    `https://${host}/graphql?op=${encodeURIComponent(operation.operationName)}`,
});

const dropSubscriptionLink = createLink({
  fetch: () => new Promise(() => {}),
});

export default () => {
  const authToken = getAuthToken();
  let cleanup = () => {};
  let subscriptionLink;

  if (authToken == null) {
    subscriptionLink = dropSubscriptionLink;
  } else {
    const socket = createOrGetSocket(authToken);
    subscriptionLink = createAbsintheSocketLink(AbsintheSocket.create(socket));

    cleanup = () => {
      socket.disconnect();
    };
  }

  return [
    ApolloLink.split(
      ({ query }) => {
        const def = getMainDefinition(query);
        return (
          def.kind === 'OperationDefinition' && def.operation === 'subscription'
        );
      },
      // @ts-expect-error
      subscriptionLink,
      httpLink,
    ),
    cleanup,
  ] as const;
};
